// extracted by mini-css-extract-plugin
export var scrollArea = "_nn-0";